module.exports = __webpack_public_path__ + "static/media/HelpAI1.a63c8d89.jpg";